import { ControlledMaskInput } from '@sravni/cosago-react-library/lib/components';
import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';
import { removeSpaces } from '@sravni/cosago-react-library/lib/utils';
import { Typography } from '@sravni/react-design-system';

import { Masks } from 'constants/masks';

import type { TPassportFormFields } from 'entities/creditForm';

export const Snils = ({ type, ...props }: IFieldFactoryProps) => {
  const { trigger } = useFormContext<TPassportFormFields>();

  const handleBlur = () => {
    trigger(type as keyof TPassportFormFields);
  };

  return (
    <div onBlur={handleBlur}>
      <ControlledMaskInput
        {...props}
        name={type}
        mask={Masks.SNILS}
        transformOutput={removeSpaces}
        inputMode="numeric"
      />
      <Typography.Text
        size={12}
        className="h-mt-4 h-ml-16 h-color-D60"
      >
        со СНИЛСом вероятность одобрения точнее
      </Typography.Text>
    </div>
  );
};
